/**
 * Composants UI partages pour le multi-branche RealEase (Bretagne / Nord).
 * Reutilises depuis App.js, CeoDashboardPage.js, ClientsDirectoryPage.js, etc.
 */
import React from 'react';

export const BRANCH_DISPLAY = {
  bretagne: { label: 'Bretagne', long: 'RealEase Bretagne', cls: 'bg-[#13736D] text-white' },
  nord: { label: 'Nord', long: 'RealEase Nord', cls: 'bg-[#272526] text-[#ECC19B]' },
};

export const branchInfo = (b) => BRANCH_DISPLAY[b] || BRANCH_DISPLAY.bretagne;

export const BranchBadge = ({ branch, size = 'sm' }) => {
  if (!branch) return null;
  const info = branchInfo(branch);
  const sz = size === 'xs' ? 'text-[9px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wider ${info.cls} ${sz}`}
          data-testid={`branch-badge-${branch}`} title={info.long}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70"></span>
      {info.label}
    </span>
  );
};

export const BranchPageHeader = ({ user, baseTitle }) => {
  if (!user) return null;
  if (user.cross_branch_access) return null;
  const info = branchInfo(user.branch || 'bretagne');
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1 ${info.cls} text-xs font-bold uppercase tracking-wider rounded-full mb-2`}
         data-testid="branch-page-header">
      <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 1l3.09 6.26L22 8.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 13.14 2 8.27l6.91-1.01L12 1z" /></svg>
      {info.long}{baseTitle ? ` — ${baseTitle}` : ''}
    </div>
  );
};

export const BranchFilter = ({ value, onChange, testidPrefix = 'crm' }) => {
  const opts = [
    { v: 'all', label: 'Toutes branches', cls: 'bg-gray-200 text-gray-800' },
    { v: 'bretagne', label: 'Bretagne', cls: 'bg-[#13736D] text-white' },
    { v: 'nord', label: 'Nord', cls: 'bg-[#272526] text-[#ECC19B]' },
  ];
  return (
    <div className="inline-flex items-center gap-1 p-1 bg-gray-100 rounded-lg" data-testid={`${testidPrefix}-branch-filter`}>
      {opts.map(o => (
        <button key={o.v} onClick={() => onChange(o.v)}
                className={`px-3 py-1 text-xs font-bold uppercase tracking-wide rounded-md transition-all ${value === o.v ? `${o.cls} shadow-sm` : 'text-gray-500 hover:text-gray-800'}`}
                data-testid={`${testidPrefix}-branch-filter-${o.v}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
};

export const useBranchFilter = (defaultValue = 'all') => {
  const [branchFilter, setBranchFilterState] = React.useState(() => {
    if (typeof localStorage === 'undefined') return defaultValue;
    return localStorage.getItem('realease_branch_filter') || defaultValue;
  });
  const setBranchFilter = React.useCallback((v) => {
    setBranchFilterState(v);
    try { localStorage.setItem('realease_branch_filter', v); } catch {}
  }, []);
  return [branchFilter, setBranchFilter];
};
